module.exports = __webpack_public_path__ + "static/img/szafa_15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/szafa_15.svg
// module id = 5hnk
// module chunks = 0